// @flow
import {cookieOptions} from './cookieUtils';

import type {SearchRequest} from '@homeaway/search-url-parser';
import type {HapiCookieState} from './cookieUtils';
import type {TypeaheadSuggestion} from '../queries/searchQuery';

export const LOCATION_COOKIE = 'ha-state-prst';

export type LocationCookie = {
    lbsKeywords?: string,
    lastSearchUrl?: string
};

/**
 * Returns a value suitable for storing as a "recent" typeahead value. Prefers a
 * resolved typeahead value, but will attempt to un-canonicalize (remove dashes
 * from) a url keyword value like `hot-tub-and-fireplace`. This process isn't
 * perfect, since canonicalization will also strip out certain special chars we
 * can't reconstruct, but is better than a) not storing a value, or b) leaving
 * in the dashes which the user didn't type.
 * @param {*} keywords
 * @param {*} typeaheadSuggestion
 */
export const getLocationCookieKeywords = (
    keywords: string | void,
    typeaheadSuggestion: ?TypeaheadSuggestion
): string | void => {
    if (typeaheadSuggestion) {
        return typeaheadSuggestion.term;
    }

    const undasherizedKeywords = keywords
        ? keywords.replace(/-/g, ' ')
        : keywords;

    return undasherizedKeywords;
};

export const locationDataCookie = (
    searchRequest: SearchRequest,
    searchRequestURL: string,
    typeaheadSuggestion: ?TypeaheadSuggestion
): HapiCookieState => {
    const lbsKeywords = getLocationCookieKeywords(
        searchRequest.q,
        typeaheadSuggestion
    );
    const lastSearchUrl = decodeURIComponent(searchRequestURL);
    return {
        name: LOCATION_COOKIE,
        data: encodeURIComponent(
            JSON.stringify({
                lbsKeywords,
                lastSearchUrl
            })
        ),
        options: cookieOptions
    };
};

// Facade for grabbing window.location. Makes testing easier?
export const getWindowLocation = (): ?Location =>
    typeof window !== 'undefined' ? window.location : null;
